import React, { useRef } from "react";

import "./searchBar.css";
import SearchIcon from "../assets/icons/searchIcon";

interface SearchBarProps {
    placeholder?: string;
    onSearch: (query: string) => void;
    onFocus?: (focused: boolean) => void;
    search: string;
    grey?: boolean;
}

export default function SearchBar(props: SearchBarProps) {

    /**
     * At the moment i removed the functionality, that instruments are only visible when the search bar is focused,
     * problems occured that the onclick event didnt trigger
     */

    return (
        <div className={"search-bar" + (props.grey ? " grey" : "")}>
            <SearchIcon/>
            <input 
                onFocus={(e) => {
                    //if(props.onFocus) props.onFocus(true);
                }}
                onBlur={(e) => {
                    //if(props.onFocus) props.onFocus(false);
                }}
                value={props.search} onChange={(e) => props.onSearch(e.target.value)} type="text" placeholder={props.placeholder || "Search"}/>
        </div>
    );
}